<template>
<v-container :style="{ background: `#30373f url(${footerBg}) no-repeat right bottom `}" fluid>
    <v-row>
      <v-col cols="12" md="12">
        <v-container>
          <v-row>
            <v-col cols="12" md="4" style="text-align: left;">
              <p style="font-size: 18px;font-weight: 700;color: white;"  @click="editContent('footer.browse')" >{{ $vuetify.lang.t('$vuetify.footer.browse') }}</p>
              <v-row>
                <v-col cols="12" md="6" class="pt-0">
                  <v-list dark style="background: transparent">
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.about')" to="/about" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.about') }}</v-list-item-title></v-list-item>
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.request_quotation')" to="/request-quotation" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.request_quotation') }}</v-list-item-title></v-list-item>
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.services')" to="/services" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.services') }}</v-list-item-title></v-list-item>
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.team')" to="/about#team" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.team') }}</v-list-item-title></v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="pt-0">
                  <v-list dark style="background: transparent">
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.faq')" to="/faq" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.faq') }}</v-list-item-title></v-list-item>
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.contact')" to="/contact" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.contact') }}</v-list-item-title></v-list-item>
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.privacy')" to="/" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.privacy') }}</v-list-item-title></v-list-item>
                    <v-list-item class="footer-link" :ripple="false" @click="editContent('footer.sitemap')" to="/" dense><v-list-item-title>{{ $vuetify.lang.t('$vuetify.footer.sitemap') }}</v-list-item-title></v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="4" style="text-align: left;" class="footer-list">
              <p style="font-size: 18px;font-weight: 700;color: white;" @click="editContent('footer.office')">{{ $vuetify.lang.t('$vuetify.footer.office') }}</p><br/>
              <p><b @click="editContent('footer.address_title')">{{ $vuetify.lang.t('$vuetify.footer.address_title') }}</b>: <span @click="editContent('footer.address_content')">{{ $vuetify.lang.t('$vuetify.footer.address_content') }}</span></p>
              <p><b @click="editContent('footer.phone_title')">{{ $vuetify.lang.t('$vuetify.footer.phone_title') }}</b>: <span @click="editContent('footer.phone_content')">{{ $vuetify.lang.t('$vuetify.footer.phone_content') }}</span></p>
              <p><b @click="editContent('footer.email_title')">{{ $vuetify.lang.t('$vuetify.footer.email_title') }}</b>: <span @click="editContent('footer.email_content')">{{ $vuetify.lang.t('$vuetify.footer.email_content') }}</span></p>
              <p><b @click="editContent('footer.working_time_title')">{{ $vuetify.lang.t('$vuetify.footer.working_time_title') }}</b>: <span @click="editContent('footer.working_time_content')">{{ $vuetify.lang.t('$vuetify.footer.working_time_content') }}</span></p>
              <p><b style="opacity: 0;">{{ $vuetify.lang.t('$vuetify.footer.working_time_title') }}:</b> <span @click="editContent('footer.working_time_content_saturday')">{{ $vuetify.lang.t('$vuetify.footer.working_time_content_saturday') }}</span></p>
            </v-col>
            <v-col cols="12" md="4" style="text-align: right; position: relative;">
              <img src="https://i.imgur.com/CG2xm1R.png" width="148px" />
              <div>
                <img :src="certif" width="58" style="position: absolute; left: 19px; top: 19px;" />
              </div>
              <br>
              <div style="margin-top:20px;">
                <v-btn dark icon><v-icon>mdi-facebook</v-icon></v-btn>
                <v-btn dark icon><v-icon>mdi-google-plus</v-icon></v-btn>
                <v-btn dark icon><v-icon>mdi-linkedin</v-icon></v-btn>
                <v-btn dark icon><v-icon>mdi-twitter</v-icon></v-btn>
                <v-btn dark icon><v-icon>mdi-youtube</v-icon></v-btn>
              </div>
              <div style="margin-top:20px; color: #95999e; font-size:14px;">
                © {{ new Date().getFullYear() }} Prime Shipping Agency. All rights reserved.
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>

import certif from "../../../assets/bottom_certification.png"
import footerBg from "../../../assets/footer-bg.png"

export default {
  name: 'footer-prime',
  data: () => ({
    footerBg: footerBg,
    certif
  }),
  methods: {
    editContent(name){
      this.$emit('editContent', name)
    }
  }
  
}
</script>
<style>
.footer-link:before{
  opacity: 0 !important;
}
.footer-link:hover {
  background: transparent;
  
}
.footer-link {
  color: white !important;
}
.footer-link:after {
  position: absolute;
  min-height:2px !important;
  height: 2px !important;
  left: 15px;
  right: 0;
  bottom: 0px;
  content: "";
  background: #2196f3;
  opacity:0;
  transition: all .2s ease-in-out;
  width:0;
}
.footer-link:hover:after{
  opacity: 1;
  width:35px;
  
}
.on-hover {
  background: #1976d2;
  color: white!important;
}
.on-hover-about {
  background: white;
  color: #515151!important;
}
.footer-list p {
  margin-bottom: 10px;
  color: #e8edf4;
  font-size: 14px;
  letter-spacing: 0px;
}
.footer-list p b{
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/views/website/commons/footer.vue